import { render, staticRenderFns } from "./GroupHeaderWrapper.vue?vue&type=template&id=dfcc1616&scoped=true&"
import script from "./GroupHeaderWrapper.vue?vue&type=script&lang=ts&"
export * from "./GroupHeaderWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./GroupHeaderWrapper.vue?vue&type=style&index=0&id=dfcc1616&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcc1616",
  null
  
)

export default component.exports